import {useCallback} from 'react'
import {useSearchParams} from 'react-router-dom'

/* eslint-disable i18next/no-literal-string -- URL-tab keys, not user-facing */
export const RelationshipSchemaTab = {
    ENTRIES: 'entries',
    VIOLATIONS: 'violations',
} as const
/* eslint-enable i18next/no-literal-string */
export type RelationshipSchemaTab = typeof RelationshipSchemaTab[keyof typeof RelationshipSchemaTab]

const TAB_PARAM = 'tab'

export interface RelationshipSchemaTabState {
    activeTab: RelationshipSchemaTab
    setActiveTab: (tab: RelationshipSchemaTab) => void
    rawTabParam: string | null
}

export function useRelationshipSchemaTab(): RelationshipSchemaTabState {
    const [searchParams, setSearchParams] = useSearchParams()
    const rawTabParam = searchParams.get(TAB_PARAM)
    const activeTab: RelationshipSchemaTab =
        rawTabParam === RelationshipSchemaTab.VIOLATIONS
            ? RelationshipSchemaTab.VIOLATIONS
            : RelationshipSchemaTab.ENTRIES

    const setActiveTab = useCallback(
        (tab: RelationshipSchemaTab) => {
            setSearchParams(
                (prev) => {
                    const next = new URLSearchParams(prev)
                    if (tab === RelationshipSchemaTab.ENTRIES) {
                        next.delete(TAB_PARAM)
                    } else {
                        next.set(TAB_PARAM, tab)
                    }
                    return next
                },
                {replace: true},
            )
        },
        [setSearchParams],
    )

    return {activeTab, setActiveTab, rawTabParam}
}
